import fs from 'fs'
import { checkIfFileExists } from './check-if-file-exists'
import { compileTsFile } from './compile-ts-file'
import { getLogger } from './logging/logger-factory'

const logger = getLogger()

export function compileConfigFile(filePath: string) {
	if (!checkIfFileExists(filePath)) {
		logger.debug(`\n× Missing or invalid config.ts at ${filePath}`)
		return null
	}
	const contents = fs.readFileSync(filePath, 'utf-8')
	return compileTsFile(contents)
}

// TODO:  Maybe also allow .js files here
export function getConfig({ filePath }: { filePath: string }): unknown | null {
	const configFile = compileConfigFile(filePath)

	if (!configFile) {
		logger.debug(`No file found at ${filePath} config file found;`)
		return null
	}
	return configFile
}
